if (!customElements.get('sumitomo-policy-content')) {
  customElements.define(
    'sumitomo-policy-content',
    class SumitomoPolicyContent extends HTMLElement {
      connectedCallback() {
        const toc = this.querySelector('[data-policy-toc]');
        const headings = this.querySelectorAll('[data-policy-body] h2');
        if (!toc || !headings.length) return;

        headings.forEach((h, i) => {
          if (!h.id) h.id = 'section-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          a.className = 'sumitomo-toc-link';
          li.append(a);
          toc.append(li);
        });
      }
    }
  );
}
